module.exports = __webpack_public_path__ + "img/howto1.3f489558.png";